export const SHARD_CATALOG_GROUP_COPY: Record<string, string> = {
	customer: 'Customer',
	org: 'Organization',
	user: 'User'
};
